import { ReactNode } from 'react';

import { cn } from '@/utils/tailwind';

import {
  CELL_PADDING,
  MAX_CELL_HEIGHT,
} from '../../DatasetSessionCompare.utils';
import { ATTACHMENTS_COLUMN_IDX, DEFAULT_COLUMN_WIDTHS } from '../../constants';
import { isInPlayground } from '../../utils/isInPlayground';

interface AttachmentsCellProps {
  isAttachmentsHidden: boolean;
  isTextTruncated: boolean;
  backgroundStyles: string;
  columnWidthStorage: number[];
  hasAttachments: boolean;
  hoverButton: ReactNode;
  attachmentContent: ReactNode;
  columnIndex?: number;
}

export function AttachmentsCell({
  isAttachmentsHidden,
  isTextTruncated,
  backgroundStyles,
  columnWidthStorage,
  hasAttachments,
  hoverButton,
  attachmentContent,
  columnIndex,
}: AttachmentsCellProps) {
  const inPlayground = isInPlayground();
  const resolvedColumnIndex = columnIndex ?? ATTACHMENTS_COLUMN_IDX;
  const width =
    columnWidthStorage[resolvedColumnIndex] ?? DEFAULT_COLUMN_WIDTHS;
  const padding = CELL_PADDING(inPlayground ? 'lg' : 'sm');
  return (
    !isAttachmentsHidden && (
      <td
        className={cn(
          'group relative border-b border-r border-secondary transition-colors',
          !isTextTruncated && 'align-top',
          backgroundStyles
        )}
        data-column={resolvedColumnIndex}
        style={{
          width,
          maxWidth: width,
          minWidth: width,
          ...padding,
          paddingTop: !isTextTruncated ? padding['paddingTop'] : undefined,
          paddingBottom: !isTextTruncated
            ? padding['paddingBottom']
            : undefined,
        }}
      >
        {hasAttachments ? (
          <div
            className={cn(
              'flex h-full shrink items-start',
              isTextTruncated
                ? 'overflow-x-auto no-scrollbar'
                : `overflow-y-auto`
            )}
            style={{
              maxHeight: !isTextTruncated ? MAX_CELL_HEIGHT : undefined,
            }}
          >
            {attachmentContent}
          </div>
        ) : (
          <div className="flex h-full items-center justify-center">
            <span className="text-sm text-ls-gray-200">No attachments</span>
          </div>
        )}
        {hoverButton}
      </td>
    )
  );
}
